import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import Icon from "../../Icon";
import CardSkeleton from "../../ui/Skeleton/CardSkeleton";
import { FormatInt } from "../../../utils/FormatData";
import { classNames } from "../../../utils/helpers";
import _Button from "../../generic/_Button";
import _ModalHealthApi from "../../modal/dashboard/sms/_ModalHealthApi";
const HealthApi = ({ data, loading = false }) => {
  const [visible, setVisible] = useState(false);
  const safe = data || {};

  const { pending, received, sent, errors, statusColor } = useMemo(() => {
    const received = Number(safe.i_received ?? 0);
    const sent = Number(safe.i_message ?? 0);
    const errors = Number(safe.i_errors ?? 0);

    const pending = received - (sent + errors);
    const isOk = pending === 0;

    return {
      received,
      sent,
      errors,
      pending,
      isOk,
      statusColor: isOk ? "text-green-700" : "text-red-700",
    };
  }, [safe]);

  if (loading) return <CardSkeleton />;

  return (
    <div
      className={classNames(
        "flex flex-col p-6 transition-all duration-300 transform bg-white rounded-lg bg-primary/10 hover:scale-105"
      )}
    >
      <div className="flex items-center justify-between">
        <div className="text-lg font-bold text-gray-600 dark:text-background-light pb-3">
          Mensajes API por procesar
        </div>
        <Icon icon="api" className={classNames(statusColor)} size={36} />
      </div>

      <p
        className={classNames(
          `mt-2 text-3xl font-bold text-[#101922] dark:text-background-light`,
          {
            "text-green-700": pending === 0,
            "text-red-700": pending > 0,
          }
        )}
      >
        {FormatInt(pending)}
      </p>

      <div className="flex flex-col space-y-1">
        <div className="flex gap-2">
          <div className="flex justify-start items-center px-2 rounded-lg gap-1 border">
            <span className="font-semibold text-gray-400 text-[12px]">
              Recibidos
            </span>
            <span className="font-bold text-gray-700 text-[14px]">
              {FormatInt(received)}
            </span>
          </div>

          <div className="flex justify-start items-center px-2 rounded-lg gap-1 border">
            <span className="font-semibold text-gray-400 text-[12px]">
              Enviados
            </span>
            <span className="font-bold text-gray-700 text-[14px]">
              {FormatInt(sent)}
            </span>
          </div>
        </div>

        <div className="flex gap-2">
          <div className="flex justify-start items-center px-2 rounded-lg gap-1 border">
            <span className="font-semibold text-gray-400 text-[12px]">
              Errores
            </span>
            <span className="font-bold text-gray-700 text-[14px]">
              {FormatInt(errors)}
            </span>
          </div>
        </div>

        <_Button
          icon="read_more"
          style="none"
          title="Ver Detalles"
          onClick={() => setVisible(true)}
        />
      </div>
      <_ModalHealthApi
        visible={visible}
        title="Detalles API"
        onClose={() => setVisible(false)}
      />
    </div>
  );
};

HealthApi.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
};

export default HealthApi;
